var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.9993,
    height: 19.9986,
    rx: 9.99931,
    fill: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 0C4.47721 0 0 4.47684 0 9.99931C0 10.1332 0.00263336 10.2666 0.00785114 10.3992C0.217779 5.06213 4.61114 0.799805 9.99967 0.799805C15.3882 0.799805 19.7816 5.06213 19.9915 10.3992C19.9967 10.2666 19.9993 10.1332 19.9993 9.99931C19.9993 4.47684 15.5221 0 9.99967 0Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 19.9985C15.5228 19.9985 20 15.5217 20 9.99923C20 9.86529 19.9974 9.73198 19.9921 9.59932C19.7822 14.9364 15.3889 19.1987 10.0003 19.1987C4.61179 19.1987 0.21843 14.9364 0.00850196 9.59932C0.00328344 9.73198 0.000651292 9.86529 0.00065128 9.99922C0.000650797 15.5217 4.47786 19.9985 10.0003 19.9985Z",
    fill: "#030303",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3999 6.079C11.2836 6.079 11.9999 5.38974 11.9999 4.5395C11.9999 3.68926 11.2836 3 10.3999 3C9.51618 3 8.7998 3.68926 8.7998 4.5395C8.7998 5.38974 9.51618 6.079 10.3999 6.079Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8881 7.75378L8.22393 8.19562L8.09273 8.78063L8.81275 8.90841C9.28317 9.01617 9.37597 9.17936 9.27357 9.63043L8.09273 14.9694C7.78232 16.3503 8.26073 17 9.38558 17C10.2576 17 11.2704 16.6121 11.7297 16.0794L11.8705 15.439C11.5505 15.7099 11.0832 15.8177 10.7728 15.8177C10.3328 15.8177 10.1728 15.5206 10.2864 14.9971L11.8881 7.75378Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.d4017bfbe21dfe880e1e370fd0edb16b.svg";
export { ForwardRef as ReactComponent };